import { mutate } from 'swr'

import { patchJson, putJson } from '../../../data/fetchers'
import { PatchRequest, WebEdiDto } from '../../../data/models'
import { OrderResponse, OrderResponseItem } from '../../../data/models'

// patch
export async function requestPatchOrderById(
  orderResponseId: string,
  orderDto: PatchRequest<WebEdiDto<OrderResponse>>,
): Promise<any> {
  const result = await patchJson(`/OrderResponses/${orderResponseId}`, orderDto)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(`/OrderResponses/${orderResponseId}`.toLowerCase()),
  )

  return result
}

// complete
export async function requestCompleteOrderById(
  orderResponseId: string,
  orderDto: PatchRequest<WebEdiDto<OrderResponse>>,
): Promise<any> {
  return await patchJson(
    `/OrderResponses/${orderResponseId}/complete`,
    orderDto,
  )
}

// send
export async function requestSendOrderById(
  orderResponseId: string,
  orderDto: PatchRequest<WebEdiDto<OrderResponse>>,
): Promise<any> {
  return await patchJson(`/OrderResponses/${orderResponseId}/send`, orderDto)
}

// put orderResponse
export async function requestPutOrderById(
  orderResponseId: string,
  orderDto: WebEdiDto<OrderResponse>,
): Promise<any> {
  const result = await putJson(`/OrderResponses/${orderResponseId}`, orderDto)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(`/OrderResponses/${orderResponseId}`.toLowerCase()),
  )

  return result
}

// put orderResponseItem
export async function requestPutOrderItemById(
  orderResponseId: string,
  itemId: string,
  orderDto: OrderResponseItem,
): Promise<any> {
  const result = await putJson(
    `/OrderResponses/${orderResponseId}/Items/${itemId}`,
    orderDto,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(`/OrderResponses/${orderResponseId}`.toLowerCase()),
  )

  return result
}
